module.exports = __webpack_public_path__ + "media/components/funnel/settings/spinner-24-6d582a67896417049244faa29c0be3e7.svg";